import classNames from 'classnames';

import { Address } from "../../../../models/Address";
import { LocalStorage } from '../../../../models/LocalStorage';
import { DEFAULT_COUNTRY, LIST_DEFAULT_COUNTRY } from '../../../../utils/constant';
import { apiCreateAddressBook, apiUpdateAddressBook } from '../../../../utils/api';
import AddressModal from '../../../addressBook/components/AddressModal';
import { GLOBAL_CONSTANTS } from '../../../../global/constants';
import { DComponent } from '../../../../components/DComponent';
import AddressItem from '../../../addressBook/components/AddressItem';
import AddressInfo from './components/AddressInfo';
import CheckBox from '../../../../components/CheckBox';
import { defer } from '../../../../utils/script';
import { getCountryFromPhone } from '../../../../utils/phone';
import { isMobileByWidth } from '../../../../utils/utils';
import { DCStatic } from '../../../../models/DCStatic';
import { ReceiptSource } from '../../../../models/ReceiptSource';

export default class CustomerInfo extends DComponent {
  constructor({
    parent,
    id,
    shippingData,
    billingData,
    countryList,
    handleShowError = () => { },
    getOrderDetail = () => { },
    onChangeCountry = () => { },
    onRefreshPayment = () => { },
    onConfirmInformation = () => { },
    onChangeBilling = () => { },
    isRFQOrder = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("CustomerInfo")
    }, true);
    /** @type {Address} */
    this.shippingData = shippingData;
    /** @type {Address} */
    this.billingData = billingData;
    /** @type {AddressInfo} */
    this.shippingInfo = undefined;
    /** @type {AddressInfo} */
    this.billingInfo = undefined;
    this.countryList = countryList;
    /** @type {CheckBox} */
    this.checkSame = undefined;
    /** @type {AddressModal} */
    this.addressModal = undefined;
    this.isRFQOrder = isRFQOrder;
    this.isEdited = true;
    this.handleShowError = handleShowError;
    this.getOrderDetail = getOrderDetail;
    this.onChangeCountry = onChangeCountry;
    this.onRefreshPayment = onRefreshPayment;
    this.onChangeBilling = onChangeBilling;
    this.onConfirmInformation = onConfirmInformation;
    this.typeOpenAddressBook = Address.TYPE.SHIPPING_INFO;
    this.isChangeBilling = false;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "CustomerInfo");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.checkSame = new CheckBox({
      parent: $(".same", this.element),
      labelI18n: "checkout_billingTheSame",
      checked: true,
      onChange: (value) => this.onCheckChange(value),
    })
    this.addressModal = new AddressModal({
      parent: ".main-page",
      onSelect: (address) => this.onSelectAddress(address),
    });

    let shippingTo = LocalStorage.getShippingList();
    let shipping = (LocalStorage.getShipping() || "").toUpperCase();
    this.shippingInfo = new AddressInfo({
      parent: $(".customer-info .input-list", this.element),
      phoneOptions: {
        initialCountry: shippingTo?.length > 0 && shipping && shippingTo.includes(shipping) ? shipping : DEFAULT_COUNTRY,
        onlyCountries: shippingTo?.length > 0 ? shippingTo : LIST_DEFAULT_COUNTRY,
      },
      onDialCode: (country) => this.onDialCode(country, Address.TYPE.SHIPPING_INFO),
      onChangePhone: (phoneNumber) => this.onChangePhone(phoneNumber, Address.TYPE.SHIPPING_INFO),
      countryList: this.countryList,
      type: Address.TYPE.SHIPPING_INFO,
      onCheckSave: (type, val) => this.onCheckSave(type, val),
      onSaveAddress: (type) => this.onSaveAddress(type),
    })

    let billing = (LocalStorage.getBilling() || "").toUpperCase();
    this.billingInfo = new AddressInfo({
      parent: $(".billing-info .input-list", this.element),
      phoneOptions: {
        initialCountry: billing,
      },
      onDialCode: (country) => this.onDialCode(country, Address.TYPE.BILLING_INFO),
      onChangePhone: (phoneNumber) => this.onChangePhone(phoneNumber, Address.TYPE.BILLING_INFO),
      countryList: this.countryList,
      type: Address.TYPE.BILLING_INFO,
      onCheckSave: (type, val) => this.onCheckSave(type, val),
      onSaveAddress: (type) => this.onSaveAddress(type),
    })

    this.addEventListener();
  }


  addEventListener() {
    this.element.addClass(LocalStorage.isLoggedIn() ? "logined" : "unlogined");

    $(".address-information-title", this.element).on("click", (e) => {
      let type = $(e.currentTarget).parent().attr("data-id");
      let dataAddress = type === Address.TYPE.SHIPPING_INFO ? this.shippingData : this.billingData;
      let selector = type === Address.TYPE.SHIPPING_INFO ? ".customer-info" : ".billing-info";
      if (!LocalStorage.isLoggedIn()) {
        $(selector, this.element).attr("type", "unfilled");
      } else {
        if (dataAddress.id || $(selector, this.element).attr("type") === "unfilled") {
          this.addressModal.setUp({
            type: type,
            listAddress: [],
            selectedId: type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getId() : this.billingInfo.getId()
          })
          this.typeOpenAddressBook = type;
          this.addressModal.show();
        } else {
          $(selector, this.element).attr("type", "unfilled");
        }
      }
    })
    $(".order-note textarea", this.element).on("input", function () {
      this.style.height = 'auto';
      this.style.height = (this.scrollHeight + 5) + 'px';
    })
    $(".order-note textarea", this.element).on("change", () => {
      this.isEdited = true;
    })
  }

  onCheckChange(value) {
    let shippingAddress = this.shippingInfo.getDataAddress(false, true);
    if (value) {
      let billingAddress = this.billingInfo.getDataAddress(false, true);
      let isSameAddress = Address.compareAddress(shippingAddress, billingAddress, true);
      if (!isSameAddress || this.shippingInfo.getPhone().getCountry() !== this.billingInfo.getPhone().getCountry()) {
        DCStatic.modalDialog.updateDialog({
          type: GLOBAL_CONSTANTS.DIALOG_TYPE.CONFIRM,
          icon: require("../../../../assets/images/checkout/warning.jpg"),
          titleI18n: "common_areYouSure",
          descriptionI18n: "checkout_billingTheSameNotice",
          btnSubmitI18n: "common_yes",
          btnCancelI18n: "common_noKeepCurrent",
          onSubmit: () => {
            this.setSameBilling(value, shippingAddress);
            typeof this.onConfirmInformation === "function" && this.onConfirmInformation();
            DCStatic.modalDialog.hide();
          },
          onCancel: () => {
            this.checkSame.setValue(false);
          }
        });
        DCStatic.modalDialog.show();
        return;
      }
    }
    this.setSameBilling(value, shippingAddress);
    typeof this.onConfirmInformation === "function" && this.onConfirmInformation(true, !value ? false : undefined);
  }

  setSameBilling(isSame, data) {
    this.setIsEdit();
    this.billingData = data;
    this.billingInfo.fillData(data);


    this.fillAddressBookToBox(Address.TYPE.BILLING_INFO, data, this.isRFQOrder);
    this.setActiveBilling(isSame);
    if (!isSame) {
      $(".billing-info", this.element).attr("type", $(".customer-info", this.element).attr("type"));
      // scrollTo(".billing-info", 0, 1500);
    } else {
      this.billingInfo.setPhoneCountry(this.shippingInfo.getPhone().getCountry());
    }
  }

  onDialCode(countryCode, type) {
    if (type === Address.TYPE.SHIPPING_INFO) {
      $(".customer-info", this.element).attr("type", "unfilled");
      if (countryCode !== LocalStorage.getShipping()) {
        this.checkChangeCountry(countryCode, "phone");
      }
    }
    if (type === Address.TYPE.BILLING_INFO) {
      LocalStorage.setBilling(countryCode);
      this.billingInfo.setAddressCountry(countryCode);
      this.isChangeBilling = true;
      typeof this.onChangeBilling === "function" && this.onChangeBilling();
    }
  }

  onChangePhone(phone, type) {
    if (type === Address.TYPE.BILLING_INFO) {
      this.isChangeBilling = true;
      typeof this.onChangeBilling === "function" && this.onChangeBilling();
    }
  }

  fillAddressInfo() {
    defer(() => !this.isLoading(), () => {
      let shipping = this.shippingData;

      if (!this.isRFQOrder) {
        let currentShipping = LocalStorage.getShipping();
        let isSameCountry = this.shippingInfo.isSameCountry(shipping.phoneNumber, currentShipping);
        if (!isSameCountry) {
          shipping = new Address();
        }
      }

      this.shippingData = shipping;
      this.shippingInfo.fillData(shipping);
      this.fillAddressBookToBox(Address.TYPE.SHIPPING_INFO, shipping);

      if (!this.isRFQOrder) {
        let billing = this.billingData, isSameAddress = Address.compareAddress(shipping, billing, true);
        this.checkSame.setValue(isSameAddress);
        this.setActiveBilling(isSameAddress);
        this.billingData = isSameAddress ? shipping : billing;
        this.billingInfo.fillData(isSameAddress ? shipping : billing);
        this.fillAddressBookToBox(Address.TYPE.BILLING_INFO, isSameAddress ? shipping : billing);
      }
    })
  }

  setAddressInfo(address, type = Address.TYPE.SHIPPING_INFO) {
    defer(() => !this.isLoading(), () => {
      if (type === Address.TYPE.SHIPPING_INFO) {
        this.shippingData = address;
        this.shippingInfo.fillData(address);
        this.shippingInfo.setActiveField(this.isRFQOrder);
      } else {
        this.billingData = address;
        this.billingInfo.fillData(address);
        this.billingInfo.setActiveField(this.isRFQOrder);
      }
      this.fillAddressBookToBox(type, address);
    })
  }

  setActiveBilling(checked) {
    checked ? $(".billing-info", this.element).addClass("hide") : $(".billing-info", this.element).removeClass("hide");
  }

  loginSuccess(type) {
    this.element.addClass("logined").removeClass("unlogined");
    this.onSaveAddress(type);
  }

  /** @param {Address} address */
  onSelectAddress(address) {
    let type = this.typeOpenAddressBook;
    this.setIsEdit(true);
    if (this.isRFQOrder) {
      this.shippingInfo.resetAddress(true);
      let newAddress = Address.fromApiObject({
        first_name: address.firstName,
        email: address.email,
      })
      this.setAddressInfo(newAddress, type);
      return;
    }
    let checkSame = this.checkSame.getValue();
    if (type === Address.TYPE.SHIPPING_INFO) {
      if (Address.compareAddress(address, this.shippingInfo.getDataAddress(false, true), true)) return;
      let shippingTo = LocalStorage.getShippingList();
      let countryPhone = getCountryFromPhone(address.phoneNumber);

      if (shippingTo?.length && shippingTo.includes(countryPhone)) {
        let shipping = (LocalStorage.getShipping() || "").toUpperCase();
        let isSameCountry = this.shippingInfo.isSameCountry(address.phoneNumber, shipping);

        if (!isSameCountry) {
          let oldShip = this.shippingInfo.getPhone().getCountry();
          let newShip = this.shippingInfo.getDialCode(address.phoneNumber);
          DCStatic.modalDialog.updateDialog({
            type: GLOBAL_CONSTANTS.DIALOG_TYPE.CONFIRM,
            icon: require("../../../../assets/images/checkout/warning.jpg"),
            titleI18n: "common_notice",
            descriptionI18n: "checkout_confirmText",
            btnSubmitI18n: "checkout_clearConfirm",
            btnCancelI18n: "checkout_notClearConfirm",
            onSubmit: () => {
              this.shippingInfo.resetAddress(true);
              this.setAddressInfo(address, type);
              if (checkSame) {
                this.billingInfo.resetAddress(true);
                this.setAddressInfo(address, Address.TYPE.BILLING_INFO);
              }
              typeof this.onChangeCountry === "function" && this.onChangeCountry({
                countryCode: newShip,
                isConfirmInformation: true,
                isBackShoppingCart: true,
              });
              DCStatic.modalDialog.hide();
            },
            onCancel: () => {
              typeof this.onChangeCountry === "function" && this.onChangeCountry({ countryCode: oldShip });
            }
          });
          DCStatic.modalDialog.show();
          return;
        }
      } else {
        this.showNotSupportDelivery();
        return;
      }
      this.setAddressInfo(address, type);
      if (checkSame) this.setAddressInfo(address, Address.TYPE.BILLING_INFO);
      typeof this.onConfirmInformation === "function" && this.onConfirmInformation();
    } else {
      if (Address.compareAddress(address, this.billingInfo.getDataAddress(false, true), true)) return;
      this.setAddressInfo(address, type);
      typeof this.onConfirmInformation === "function" && this.onConfirmInformation();
    }
  }

  showNotSupportDelivery() {
    DCStatic.modalDialog.updateDialog({
      type: GLOBAL_CONSTANTS.DIALOG_TYPE.NOTICE,
      icon: require("../../../../assets/images/checkout/warning.jpg"),
      titleI18n: "common_notice",
      descriptionI18n: "checkout_noSupportDelivery",
      btnSubmitI18n: "common_OKBoth",
    });
    DCStatic.modalDialog.show();
  }

  /**
   * @param {Address} address 
   */
  fillAddressBookToBox(type, address) {
    var selector = type === Address.TYPE.SHIPPING_INFO ? ".customer-info" : ".billing-info";
    if (!address?.isBox() || this.isRFQOrder) {
      $(selector, this.element).attr("type", "unfilled");
      return;
    }
    $(`${selector} .address-data`, this.element).html("");
    new AddressItem({
      parent: $(`${selector} .address-data`, this.element),
      address: address,
      hideIcon: true,
      isReadOnly: true,
    })
    $(selector, this.element).attr("type", "filled");
    $(`${selector} .address-data .btn-edit`, this.element).off("click");
    $(`${selector} .address-data .btn-edit`, this.element).on("click", function (e) {
      $(selector, this.element).attr("type", "unfilled");
    })
  }

  onCheckSave(type, val) {
    if (val) {
      type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.setIsEdit(true) : this.billingInfo.setIsEdit(true);
    }
    if (val && !LocalStorage.isLoggedIn()) {
      let receiptSource = LocalStorage.getReceiptSource();
      if (receiptSource?.loginUrl) {
        const onCallBack = () => {
          this.element.addClass("logined").removeClass("unlogined");
          this.shippingInfo.setLogined(true);
          this.billingInfo.setLogined(true);
        };
        const onHideCallBack = () => {
          if (!LocalStorage.isLoggedIn()) {
            if (type === Address.TYPE.SHIPPING_INFO) this.shippingInfo.checkSave.setValue(false);
            if (type === Address.TYPE.BILLING_INFO) this.billingInfo.checkSave.setValue(false);
          }
        };

        DCStatic.phoneNumber = type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getPhone().getNumber() : this.billingInfo.getPhone().getNumber();
        DCStatic.displayName = type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getName().getValue() : this.billingInfo.getName().getValue();
        DCStatic.email = type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getEmail().getValue() : this.billingInfo.getEmail().getValue();
        DCStatic.authSocial.setCallBack(onCallBack);
        DCStatic.authSocial.setHideCallBack(onHideCallBack);
        DCStatic.authSocial.showAuth();
      } else {
        ReceiptSource.login();
      }
    }
  }

  onSaveAddress(type) {
    let checkSave = type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getCheckSave() : this.billingInfo.getCheckSave();
    let addressData = type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getDataAddress(false, true) : this.billingInfo.getDataAddress(false, true);
    let isEdited = type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getIsEdited() : this.billingInfo.getIsEdited();
    if (checkSave) {
      if (LocalStorage.isLoggedIn()) {
        if (isEdited) {
          let params = type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.getParamsAddress(false, true) : this.billingInfo.getParamsAddress(false, true);
          this.setLoading(type, true);
          delete params[Address.PARAMS.ADDRESS_TYPE];
          if (params.id) {
            apiUpdateAddressBook(params.id, params,
              () => {
                if (type === Address.TYPE.SHIPPING_INFO) {
                  this.shippingData = addressData;
                  if (this.checkSame.getValue()) this.billingData = addressData;
                } else {
                  this.billingData = addressData;
                }
                this.setLoading(type, false);
                this.setInformationBoxAfterSave(type, addressData);
              },
              (error) => {
                typeof this.handleShowError === "function" && this.handleShowError(error);
                this.setLoading(type, false);
              }
            )
          } else {
            delete params.id;
            apiCreateAddressBook(params,
              (data) => {
                let newShipping = Address.fromApiObject(data.data);
                this.setAddressInfo(newShipping, type);
                this.setLoading(type, false);
                if (type === Address.TYPE.SHIPPING_INFO && this.checkSame.getValue()) {
                  this.setAddressInfo(newShipping, Address.TYPE.BILLING_INFO);
                }
                this.validateInformation(type);
              },
              (error) => {
                typeof this.handleShowError === "function" && this.handleShowError(error)
                this.setLoading(type, false);
              }
            )
          }
        } else {
          this.setInformationBoxAfterSave(type, addressData);
        }
      } else {
        DCStatic.phoneNumber = this.billingInfo.getPhone().getNumber() || this.shippingInfo.getPhone().getNumber();
        DCStatic.displayName = this.billingInfo.getName().getValue() || this.shippingInfo.getName().getValue();
        DCStatic.email = this.billingInfo.getEmail().getValue() || this.shippingInfo.getEmail().getValue();
        DCStatic.authSocial.setCallBack(() => this.loginSuccess(type));
        DCStatic.authSocial.showAuth();
      }
    } else {
      this.setInformationBoxAfterSave(type, addressData);
    }
  }

  /** @param {Address} address */
  setInformationBoxAfterSave(type, address) {
    this.fillAddressBookToBox(type, address);
    if (type === Address.TYPE.SHIPPING_INFO && this.checkSame.getValue()) {
      this.setAddressInfo(address, Address.TYPE.BILLING_INFO);
    }
    this.validateInformation(type);
  }

  validateInformation(type, isSaveInfo = true) {
    let checkSame = this.checkSame.getValue();
    if (!checkSame) {
      if (type === Address.TYPE.SHIPPING_INFO) {
        if (!this.billingInfo.getDataAddress().isBox()) {
          this.scrollToBilling();
        }
      }
      if (type === Address.TYPE.BILLING_INFO) {
        if (!this.shippingInfo.getDataAddress().isBox()) {
          this.scrollToShipping();
        }
      }
    }

    typeof this.onConfirmInformation === "function" && this.onConfirmInformation();
  }

  scrollToBilling() {
    if (!isMobileByWidth()) {
      $("html, body").animate({
        scrollTop: $(".billing-info", this.element)[0].offsetTop + 72
      }, 1000);
    }
  }

  scrollToShipping() {
    if (!isMobileByWidth()) {
      $("html, body").animate({
        scrollTop: $(".customer-info", this.element)[0].offsetTop + 72
      }, 1000);
    }
  }

  checkChangeCountry(newShip, type = "phone", currencyCodeOld) {
    if (this.isRFQOrder) return;
    let shipping = (LocalStorage.getShipping() || "").toUpperCase();
    let oldShip = (type === "phone" ? shipping : this.shippingInfo.getPhone().getCountry()) || DEFAULT_COUNTRY;
    if (newShip !== oldShip) {
      // if ((this.shippingInfo.getPhone().getNumber() || this.shippingInfo.getAddress().getValue())) {
      DCStatic.modalDialog.updateDialog({
        type: GLOBAL_CONSTANTS.DIALOG_TYPE.CONFIRM,
        icon: require("../../../../assets/images/checkout/warning.jpg"),
        titleI18n: "common_notice",
        descriptionI18n: "checkout_confirmText",
        btnSubmitI18n: "checkout_clearConfirm",
        btnCancelI18n: "checkout_notClearConfirm",
        onSubmit: () => {
          this.setShippingPhone(newShip);
          this.shippingInfo.resetAddress(true);
          if (this.checkSame.getValue()) {
            this.setBillingPhone(newShip);
            this.billingInfo.resetAddress(true);
          }
          typeof this.onChangeCountry === "function" && this.onChangeCountry({
            countryCode: newShip,
            isBackShoppingCart: true,
          });
          this.validateAddressInfo(this.isRFQOrder);
          DCStatic.modalDialog.hide();
        },
        onCancel: () => {
          typeof this.onChangeCountry === "function" && this.onChangeCountry({
            countryCode: oldShip,
            currencyCodeOld: currencyCodeOld,
          });
          if (type === "phone") {
            this.shippingInfo.setPhoneCountry(oldShip);
            // this.shippingInfo.setPhoneNumber(this.shippingData.phoneNumber);
          }
        }
      });
      DCStatic.modalDialog.show();
    } else {
      this.setShippingPhone(newShip);
      this.shippingInfo.resetAddress(true);
      if (this.checkSame.getValue()) {
        this.setBillingPhone(newShip);
        this.billingInfo.resetAddress(true);
        typeof this.onRefreshPayment === "function" && this.onRefreshPayment();
      };
    }
  }

  setShippingPhone(code) {
    this.shippingInfo.setPhoneCountry(code);
    this.shippingInfo.addressForm.phone.setNumber("");
    this.shippingInfo.setAddressCountry(code);
  }

  setBillingPhone(code) {
    this.billingInfo.setPhoneCountry(code);
    this.billingInfo.addressForm.phone.setNumber("");
    this.billingInfo.setAddressCountry(code);
    LocalStorage.setBilling(code);
  }

  getIsChangeBilling() {
    return this.isChangeBilling;
  }

  setIsChangeBilling(isChange) {
    this.isChangeBilling = isChange;
  }

  validateAddressInfo(isRFQ = false) {
    if (isRFQ) {
      return this.shippingInfo.validateForm(true, true);
    }
    if (this.checkSame.getValue()) {
      return this.shippingInfo.validateForm(true);
    }
    return this.shippingInfo.validateForm(true) && this.billingInfo.validateForm(true);
  }

  setLoading(type, isLoading = false) {
    type === Address.TYPE.SHIPPING_INFO ? this.shippingInfo.setSaveLoading(isLoading) : this.billingInfo.setSaveLoading(isLoading);
  }

  isLoading() {
    return !this.shippingInfo || !this.billingInfo || (this.shippingInfo.getLoadingInput() && this.billingInfo.getLoadingInput());
  }

  setActiveElement(isRFQ = false) {
    defer(() => !this.isLoading(), () => {
      this.isRFQOrder = isRFQ;
      this.shippingInfo.setActiveField(isRFQ);
      if (isRFQ) {
        this.element.addClass("is-rfq");
        $(".customer-info", this.element).attr("type", "unfilled");
      } else {
        this.element.removeClass("is-rfq");
        this.setActiveBilling(this.checkSame.getValue());
      }
    })
  }

  setIsEdit(isEdited = true) {
    this.isEdited = isEdited;
    this.billingInfo.setIsEdit(isEdited);
    this.shippingInfo.setIsEdit(isEdited);
  }

  getParamsAddress() {
    let paramsShip = this.shippingInfo.getParamsAddress(this.isRFQOrder);
    let paramsBill = this.billingInfo.getParamsAddress(this.isRFQOrder);
    return {
      user_shipping_address_id: this.shippingInfo.getId(),
      shipping_address: paramsShip,
      user_billing_address_id: this.checkSame.getValue() ? this.shippingInfo.getId() : this.billingInfo.getId(),
      billing_address: this.checkSame.getValue() ? paramsShip : paramsBill,
      note: $(".order-note textarea", this.element).val()
    }
  }

  getIsEdited() {
    return this.isEdited || this.billingInfo.getIsEdited() || this.shippingInfo.getIsEdited();
  }

  /**
   * 
   * @returns {Address}
   */
  getDataAddressInfo() {
    return this.checkSame.getValue() ? this.shippingInfo.getDataAddress() : this.billingInfo.getDataAddress();
  }

  /** @param {CustomerInfo} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
    });
  }

  static TYPE = {
    SHIPPING_INFO: "shipping",
    BILLING_INFO: "billing"
  }
}